module.exports = __webpack_public_path__ + "static/media/M_Carousel.c64a75fc.jpg";